import { Outlet, Navigate } from "react-router-dom";
import { useProfileStore } from "../helpers/state";
import { useLoginStore } from "../helpers/state";
import moment from "moment";

const KadRoutes = () => {
  const { profile } = useProfileStore();
  const { login } = useLoginStore();

  const isAccessible = moment(login.katamEnd, "YYYY/MM/DD").isSame(
    moment(profile.pektaexpired, "YYYY/MM/DD")
  );

  // Check sessionStorage flag
  const cameFromProfile = sessionStorage.getItem("cameFromProfile");

  return isAccessible && cameFromProfile ? <Outlet /> : <Navigate to="/" />;
};

export default KadRoutes;
